import React from 'react';
import { Link } from 'react-router-dom';
import { applyImageFallback } from '../utils/imageFallback';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--cream-deep)', borderTop: '1px solid var(--border-soft)', paddingTop: 64 }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: 48, paddingBottom: 52, borderBottom: '1px solid var(--border-soft)' }} className="footer-grid">

          {/* Brand */}
          <div>
            <img
              src="/logo.png"
              alt="Glovy Jewellery"
              style={{ height: 'var(--logo-footer-h)', width: 'auto', objectFit: 'contain', marginBottom: 14 }}
              onError={applyImageFallback}
            />
            <p style={{ fontSize: 12.5, lineHeight: 1.85, color: 'var(--text-muted)', maxWidth: 210 }}>
              Handcrafted jewellery celebrating the beauty of Indian tradition.
            </p>
            <a href="https://instagram.com/glovy_jewellery" target="_blank" rel="noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 7, marginTop: 18, color: 'var(--gold)', fontSize: 11, letterSpacing: '0.5px' }}>
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              @glovy_jewellery
            </a>
          </div>

          {/* Collections */}
          <div>
            <FH>Collections</FH>
            {[['Traditional Jewellery','/traditional'],['Modern — Coming Soon','/modern'],['Necklaces','/traditional?category=NECKLACE'],['Earrings','/traditional?category=EARRINGS'],['Bracelets','/traditional?category=BRACELET']].map(([l,p])=>(
              <FL key={l} to={p}>{l}</FL>
            ))}
          </div>

          {/* Account */}
          <div>
            <FH>Account</FH>
            {[['Sign In','/login'],['Create Account','/register'],['My Orders','/orders'],['Wishlist','/wishlist'],['Profile','/account']].map(([l,p])=>(
              <FL key={l} to={p}>{l}</FL>
            ))}
          </div>

          {/* Info */}
          <div>
            <FH>Legal</FH>
            {[['Privacy Policy','/privacy-policy'],['Terms & Conditions','/terms'],['Contact Us','/contact']].map(([l,p])=>(
              <FL key={l} to={p}>{l}</FL>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '22px 0', flexWrap: 'wrap', gap: 12 }} className="footer-bottom">
          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} Glovy Jewellery. All rights reserved.
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            {['UPI', 'Cards', 'Net Banking'].map(p => (
              <span key={p} style={{ fontSize: 9, letterSpacing: '1.5px', textTransform: 'uppercase', background: 'white', border: '1px solid var(--border-soft)', padding: '4px 8px', borderRadius: 3, color: 'var(--text-muted)' }}>{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

function FH({ children }) {
  return <div style={{ fontSize: 9, letterSpacing: '3px', textTransform: 'uppercase', color: 'var(--black)', fontWeight: 500, marginBottom: 16 }}>{children}</div>;
}
function FL({ to, children }) {
  return (
    <Link to={to} style={{ display: 'block', fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 9, transition: 'color 0.2s' }}
      onMouseEnter={e => e.target.style.color = 'var(--black)'}
      onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}>
      {children}
    </Link>
  );
}